import { createContext, useContext } from 'react';

/**
 * Quickly create params based contexts conumers.
 * ### Example
 * ```tsx
 * const [MyProvider, useMyContext] = createContextQuick();
 * const App = () => {
 *  return (
 *  <MyProvider value="1" otherValue={[]}>
 *    <Child />
 *  </MyProvider>
 * );
 * };
 * ```
 */
export function createContextQuick<T extends Record<string, any>>(
  defaultVal: T = null
): readonly [ProviderContext<T>, ContextConsumerHook<T>] {
  const Context = createContext(defaultVal);
  const Provider: ProviderContext<T> = ({ children, ...props }) => (
    <Context.Provider value={props as any} children={children} />
  );
  return [Provider, () => useContext(Context)];
}

type ProviderContext<T> = (props: T & { children: React.ReactNode }) => JSX.Element;
type ContextConsumerHook<T> = () => T;
